// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zr1z","colBig":"styles_colBig__1YYMW","colSmall":"styles_colSmall__3qUUI"};